export default __webpack_public_path__ + "static/operational-efficiency-eebc3fcef8469e02b3f221eb1d751317.png";